import { authFetch } from "~/services/fetch";
import type { CalendarWorkScheduleParams, CheckAvailabilityParams, CreateWorkScheduleParams, EditWorkScheduleParams } from "../interfaces";

export async function createWorkSchedule({crew, deviceId, endDate, startDate, task, workShiftId}: CreateWorkScheduleParams) {
  const response = await authFetch({
    method: 'POST',
    url: '/work-schedule/store',
    data: {
      work_shift_id: workShiftId,
      start_date: startDate,
      end_date: endDate,
      device_id: deviceId,
      task: task,
      crew: crew
    }
  })

  return response.data;
}

export async function checkAvailability({ userId, deviceId, startDate, endDate }: CheckAvailabilityParams) {
  const response = await authFetch({
    url: '/work-schedule/check-availability',
    method: 'POST',
    data: {
      user_id: userId,
      device_id: deviceId,
      start_date: startDate,
      end_date: endDate
    }
  })

  return response.data;
}

export async function getWorkScheduleById({id}) {
  const response = await authFetch({
    url: `/work-schedule/${id}`,
    method: 'GET',
  })

  return response.data;
}

export async function calendarWorkSchedule({ filters, signal }) {
  const response = await authFetch({
    url: '/work-schedule',
    method: 'POST',
    data: {
      without_pagination: true,
      ...filters,
    },
    signal  // Passar o signal para authFetch
  })

  return response.data.data;

}

export default async function editWorkSchedule({ id, workShiftId, startDate, endDate, deviceId, task, crew }: EditWorkScheduleParams) {
  const response = await authFetch({
    url: `/work-schedule/${id}`,
    method: 'PUT',
    data: {
      work_shift_id: workShiftId,
      start_date: startDate,
      end_date: endDate,
      device_id: deviceId,
      task: task,
      crew: crew
    }
  })

  return response
}
